import React, { useState, useEffect } from "react";
import axios from "axios";
import Wrapper from "../UI/Wrapper";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import MiniDrawer from "../MiniDrawer/MiniDrawer";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { useSearchParams } from "react-router-dom";



function AccountsExpense() {

  const [searchParams] = useSearchParams();

  const encodedId = searchParams.get("id");

  let relocationId = null;

  if (encodedId) {
    try {
      relocationId = atob(encodedId); // 🔓 decode
    } catch (err) {
      console.error("Invalid ID");
    }
  }
  const location = useLocation();
  const navigate = useNavigate();

  // ✅ FINAL SAFE GET
  // const relocationId =
  //   location.state?.relocationId ||
  //   localStorage.getItem("relocationId");

  console.log("Received Relocation ID:", relocationId);

  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;

  const [expenseDetail, setExpenseDetail] = useState([]);

  const storedToken = JSON.parse(localStorage.getItem("token"));

  useEffect(() => {
    if (!relocationId) {
      console.error("Relocation ID missing");
      return;
    }

    if (!storedToken) {
      console.warn("Token missing");
      return;
    }

    fetchData();
  }, [relocationId]);

  const fetchData = async () => {
    try {
      const res = await axios.get(
        `${baseAPI}userGet/GetExpenseDetails?expense_detail_id=0&relocation_id=${relocationId}`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      console.log("API Response:", res.data);

      if (res.data && res.data.data) {
        setExpenseDetail(res.data.data);
      } else {
        setExpenseDetail([]);
      }
    } catch (error) {
      console.log("API Error:", error?.response || error.message);
      setExpenseDetail([]);
    }
  };

  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />

        <div
          className="container-fluid"
          style={{
            padding: "4rem 1rem 1rem 1rem",
            backgroundColor: "#F4F4F4",
            width: "100%",
            overflowX: "auto",
          }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "1%",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  <span> Expense List
                  </span>
                </h1>
              </div>
            </div>
            <Wrapper>
              <div style={{ padding: "20px" }}>
                {/* 🔙 Back Button */}
                {/* <button
                  onClick={() => navigate(-1)}
                  style={{
                    marginBottom: "15px",
                    padding: "6px 12px",
                    background: "#5b489d",
                    color: "#fff",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                >
                  ← Back
                </button> */}

                <h3>Expense Details</h3>

                {!relocationId && (
                  <p style={{ color: "red" }}>No Relocation ID Found</p>
                )}

                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginTop: "15px",
                  }}
                >
                  <thead>
                    <tr style={{ background: "#5b489d", color: "#fff" }}>
                      <th>S.No</th>
                      <th>Action</th>
                      <th>Relocation ID</th>
                      <th>Job ID</th>
                      <th>Amount</th>
                      <th>Expense Description</th>
                      <th>Payment Status</th>
                      <th>Payment Mode</th>
                      <th>Added By</th>
                      {/* <th>Document</th> */}
                    </tr>
                  </thead>

                  <tbody>
                    {expenseDetail.length > 0 ? (
                      expenseDetail.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            <button
                              onClick={() => {
                                if (item.attachment) {
                                  const fileURL = `${baseImageURL}/Images/FieldOpsExpenseDocuments/${item.attachment}`;
                                  window.open(fileURL, "_blank");
                                } else {
                                  alert("Document not available");
                                }
                              }}
                              className="flex items-center justify-center rounded"
                              style={{ width: "40px", height: "40px", cursor: "pointer" }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-search w-[14px] h-[14px] text-[#6a6a6a]"
                              >
                                <circle cx="11" cy="11" r="8"></circle>
                                <path d="m21 21-4.3-4.3"></path>
                              </svg>
                            </button>
                          </td>                  <td>{item.relocation_id}</td>
                          <td>{item.Job_Id}</td>

                          <td>₹ {Number(item.expense_amount || 0).toLocaleString()}</td>

                          <td>{item.description}</td>
                          <td>{item.payment_status_name}</td>
                          <td>{item.payment_mode_name}</td>
                          <td>{item.added_by}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="10" style={{ textAlign: "center" }}>
                          No Expense Has Been Added
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </Wrapper>
          </div>
        </div>
      </div>
    </>

  );
}

export default AccountsExpense;